import styled from "styled-components/macro";

export const Container = styled.div`
  padding: 15px 25px;
  padding-left: 25px;
  justify-content: space-between;
  text-align: center;
  background: white;

  h1,
  h2 {
    margin: 25px auto 15px auto;
    text-align: center;
    font-family: "GT Super Text";
  }

  h1 {
    font-size: 35px;
    margin-top: 35px;
  }

  h2 {
    margin-top: 0;
    font-size: 16px;
    font-weight: normal;
  }

  p {
    display: block;
    align-self: center;
    text-align: center;
    font-size: 16px;
    color: var(--grey-1);
    line-height: 130% !important;
    font-weight: 500;
    margin: 0;

    a {
      color: #444;
      text-decoration: underline;
    }
  }

  img {
    /* width: 150px; */
    height: 80px;
    align-self: center;
    margin-right: -12px;
  }

  ul {
    display: flex;
    margin: 10px auto;
    text-align: center;
    align-items: center;
    justify-content: center;
    margin: 45px auto 25px auto;
    gap: 25px;

    li {
      padding: 0 0 0 0;
      text-align: center;

      h3 {
        font-size: 18px;
        font-family: "GT Super Text";
        margin-bottom: 15px;
        color: #1fc2a9;
      }

      h4 {
        font-size: 23px;
        font-family: "GT Super Text";
        margin-bottom: 3px;
        margin-top: 15px;
      }

      div.container {
        margin: auto;
        width: 180px;
        /* height: 240px; */
        text-align: center;
        border-radius: 15px;
        box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.15), 0px 4px 10px rgba(0, 0, 0, 0.15);
        padding: 15px;
      }

      p {
        font-family: "GT Super Text";
        font-size: 15px;
        color: black;
      }

      button {
        margin-top: 15px !important;
        margin-bottom: 5px;
        align-self: center;
        min-width: 18 0px;
        padding: 5px 15px !important;
        white-space: nowrap;
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
        border-radius: 11px;
        border: 0;
        outline: none;
        color: white;
        font-family: Inter;
        font-size: 16px;
        cursor: pointer;

        &:hover {
          opacity: 0.7;
        }
      }

      .img {
        height: 130px;
        display: flex;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &:first-child {
        h3 {
          color: #28d487;
        }

        img {
          transform: scale(0.7);
        }

        button {
          background: #28d487;
        }
      }

      &:nth-child(2) {
        h3 {
          color: #1fc2a9;
        }

        button {
          background: #1fc2a9;
        }
      }

      &:nth-child(3) {
        h3 {
          color: #16b2c8;
        }

        img {
          width: calc(268px * 0.625);
          height: calc(166px * 0.625);
        }

        button {
          background: #16b2c8;
        }
      }

      &:nth-child(4) {
        h3 {
          color: #16b2c8;
        }

        img {
          width: calc(334px * 0.625);
          height: calc(204px * 0.625);
        }

        button {
          background: #16b2c8;
        }
      }
    }
  }
`;
